import React, { useState, useEffect, useContext } from 'react';
import styles from './AppLayout.module.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Col, Layout, Row, Spin } from 'antd';
import { fetchJsData } from '../../api';
import {
    CciApps,
    Heads,
    ScheduledCciApps,
    ScheduledConTrend,
    SchConChanges,
    ScheduledCatChange,
    ScheduledWebCatChanges,
    BulkCatChange,
    CatChange,
    Subscription,
    KnownIssuesTracker,
} from '..';
import { UserContext } from '../Reducers/UserContext';
import { ScrollToTop, NavCard } from './ScrollToTop';
import _ from 'lodash';

const { Content, Footer } = Layout;

const AppLayout = (props) => {
    const [livMenu, setLiveMenu] = useState({
        release: false,
        topMenu: 'R',
        botMenu: 'rel_cci',
    });
    const { isLoggedIn, setLogger } = useContext(UserContext);
    const [rel, setRel] = useState(null);
    const [usrRel, setUsrRel] = useState('');
    const [usrSch, setUsrSch] = useState('Scheduled');
    const [load, setLoad] = useState(true);
    const [submit, setSubmit] = useState(true);
    const [bulkCatData, setBulkCatData] = useState({ exist: 0, data: [] });

    useEffect(() => {
        if (!rel) {
            fetchData();
        }
    }, [rel]);

    const fetchData = async () => {
        setLoad(true);
        const relVersion = await fetchJsData({
            type: 'fetch',
            qry: 'fetConVersion',
        });

        const BulkTabExst = await fetchJsData({
            type: 'fetch',
            qry: 'fetTabExist',
        });

        const BulkCatData = BulkTabExst['data'][0]['exst']
            ? BulkTabExst['data'][0]['exst'] == 1
                ? await fetchJsData({
                      type: 'fetch',
                      qry: 'fetBulkCatUpdate',
                  })
                : []
            : [];

        setBulkCatData({
            exist: BulkTabExst['data'][0]['exst'] ? BulkTabExst['data'][0]['exst'] : 0,
            data: BulkCatData['data']
                ? _.filter(
                      BulkCatData['data'],
                      (item) => parseInt(item.release_name) >= parseInt(relVersion['data'][0]['curVersion'])
                  )
                : [],
        });

        setRel(relVersion['data'][0]['curVersion']);
        setUsrRel('snapshot_v' + relVersion['data'][0]['curVersion'] + '_0_0');
        setLoad(false);
    };

    return (
        <Layout className="site-layout" style={{ padding: 0, backgroundColor: '#F8F8F8' }}>
            <Switch>
                <Route
                    path="/subscribe"
                    render={() => (
                        <Subscription
                            rel={usrRel ? usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                            usrRel={usrRel}
                            loader={load}
                        />
                    )}
                    // component={Subscription}
                />
                <Layout style={{ padding: 0, backgroundColor: '#F8F8F8' }}>
                    <Heads />

                    <Row>
                        {/* <Col ></Col> */}
                        <Col
                            span={5}
                            className="gutter-row"
                            style={{
                                paddingLeft: '40px',
                                paddingRight: '10px',
                                marginTop: '5px',
                                paddingTop: '2px',
                            }}
                        >
                            <NavCard
                                livMenu={livMenu}
                                setLiveMenu={setLiveMenu}
                                setSubmit={setSubmit}
                                setUsrRel={setUsrRel}
                                bulkCatData={bulkCatData}
                                load={load}
                                submit={submit}
                                usrRel={usrRel}
                                rel={rel}
                                // rele={usrRel.substr(10, 2)}
                                rele={usrRel ? usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                                setUsrSch={setUsrSch}
                                usrSch={usrSch}
                            />
                        </Col>
                        <Col
                            span={19}
                            className="gutter-row"
                            style={{ paddingLeft: '0px', margin: '0px', paddingRight: '8px' }}
                        >
                            <ScrollToTop>
                                <Content className="bg-val">
                                    <Route
                                        exact
                                        path="/"
                                        render={() => (
                                            <CciApps
                                                submit={submit}
                                                // rel={usrRel.substr(10, 2)}
                                                rel={usrRel ? usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                                                usrRel={usrRel}
                                                setSubmit={setSubmit}
                                                loader={load}
                                                setLiveMenu={setLiveMenu}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/category_changes"
                                        render={() => (
                                            <CatChange
                                                submit={submit}
                                                // rel={usrRel.substr(10, 2)}
                                                rel={usrRel ? usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                                                usrRel={usrRel}
                                                setSubmit={setSubmit}
                                                loader={load}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/weekly_cci_apps"
                                        render={() => (
                                            <ScheduledCciApps
                                                submit={submit}
                                                // rel={usrRel.substr(10, 2)}
                                                // usrRel={usrRel}
                                                setSubmit={setSubmit}
                                                loader={load}
                                                setLiveMenu={setLiveMenu}
                                                setUsrSch={setUsrSch}
                                                usrSch={usrSch}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/weekly_connector_changes"
                                        render={() => (
                                            <SchConChanges
                                                submit={submit}
                                                setSubmit={setSubmit}
                                                loader={load}
                                                setUsrSch={setUsrSch}
                                                usrSch={usrSch}
                                                rel={usrRel ? usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                                                usrRel={usrRel}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/weekly_category_changes"
                                        render={() => (
                                            <ScheduledCatChange
                                                submit={submit}
                                                setSubmit={setSubmit}
                                                loader={load}
                                                setUsrSch={setUsrSch}
                                                usrSch={usrSch}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/weekly_web_category_changes"
                                        render={() => (
                                            <ScheduledWebCatChanges
                                                submit={submit}
                                                setSubmit={setSubmit}
                                                loader={load}
                                                setUsrSch={setUsrSch}
                                                usrSch={usrSch}
                                            />
                                        )}
                                    />
                                    <Route
                                        path="/bulk_catgeory_update"
                                        render={() =>
                                            bulkCatData['exist'] == 1 && bulkCatData['data'].length > 0 ? (
                                                <BulkCatChange
                                                    submit={submit}
                                                    rel={usrRel ? usrRel.split('snapshot_v')[1].split('_')[0] : ''}
                                                    bulkCatData={bulkCatData}
                                                    usrRel={usrRel}
                                                    setSubmit={setSubmit}
                                                    loader={load}
                                                />
                                            ) : !load ? (
                                                <div className={styles.pageNF}>
                                                    <h1>Oops! Page Not Found.</h1>
                                                </div>
                                            ) : (
                                                <div className={styles.pageNF}>
                                                    <Spin size="large" />
                                                </div>
                                            )
                                        }
                                    />
                                    <Route
                                        path="/known_issues_tracker"
                                        render={() => (
                                            <KnownIssuesTracker
                                                submit={submit}
                                                setSubmit={setSubmit}
                                                loader={load}
                                            />
                                        )}
                                    />
                                    <Route component={PageNotFound} />
                                </Content>
                            </ScrollToTop>
                        </Col>
                    </Row>
                    <Footer style={{ textAlign: 'center', backgroundColor: '#F8F8F8' }}>
                        Product Change Notification Portal ©2022
                    </Footer>
                </Layout>
            </Switch>
        </Layout>
    );
};

const Conn = (props) => (
    <div style={{ width: '100%', minHeight: '80vh' }}>
        <h1 className={styles.pageNF}>Category change</h1>
    </div>
);

const PageNotFound = (props) => {
    const paths = [
        '/',
        '/connector_changes',
        '/category_changes',
        '/weekly_cci_apps',
        '/weekly_connector_changes',
        '/weekly_category_changes',
        '/weekly_web_category_changes',
        '/subscribe',
        '/bulk_catgeory_update',
        '/known_issues_tracker',
    ];
    const bln = paths.includes(props.location.pathname);

    return !bln ? (
        <div className={styles.pageNF}>
            <h1>Oops! Page Not Found.</h1>
        </div>
    ) : (
        <></>
    );
};

export default AppLayout;
